/**
 * Extended ViewController template
 *
 * User: adic
 * Date: 5/9/13
 * Time: 3:16 PM
 */
define(function (require) {

    var WidgetViewController = require('web-agent-framework/WidgetViewController');

    var EmptyPlaceholderWidget = WidgetViewController.extend({
        ControllerName: "EmptyPlaceholderWidget",
        applicationType: 'EmptyPlaceholderWidget',

        LPViewMap: {
        },

        initialize: function (constructorData) {
            this.placeholderWidget = true;

            this.applicationType = constructorData.applicationType;
            var icon = document.createElement("button");
            this.addClass(icon, ["button_icon", constructorData.iconClass]);
            this.setIconView(icon);
        },

        events: function () {
        },

        render: function () {
        }
    });

    return EmptyPlaceholderWidget;

});
